import styled from 'styled-components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { colors } from '../../constants'

const rowHeight = '35px'

export const ListWrapper = styled.ul`
    border-radius: 5px;
    margin: 0;
    padding: 0;

    ${({ isDragging }) =>
        isDragging &&
        `
      background: ${colors.white};
      border: 1px dotted ${colors.orangelight};
      margin: -1px;
    `}
`

export const Row = styled.li`
    ${({ highLighted }) => (highLighted ? `background: ${colors.bluelighter}` : `background: ${colors.white}`)};
    ${({ onlyBorderBottom }) =>
        onlyBorderBottom ? `border-bottom: 1px solid ${colors.greylight};` : `border: none; border-radius: 0px`};
    ${({ noBorders }) => noBorders && `border: 0`};
    ${({ noBackGround }) => noBackGround && `background: transparent`};
    ${({ noStaticHeight }) => !noStaticHeight && ` height: ${rowHeight}; padding: 5px 5px;`}
    overflow: hidden;
    position: relative;

    ${({ marginBottom }) => (marginBottom ? ` margin-bottom: ${marginBottom}` : 'margin-bottom: 1px')};

    ${({ width }) => (width ? `display: inline-block; width: calc(${width} - 18px); margin-right: 18px;` : `display: block;`)};

    ${({ clickable }) => clickable && `cursor: pointer;`}

    ${({ draggable, noStaticHeight }) => draggable && !noStaticHeight && `cursor: move;`}

  ${({ draggable, isDragging }) =>
        draggable &&
        !isDragging &&
        `
      &:hover {
        background: ${colors.greylightest};
      }
    `}

  ${({ draggable, isBeingDragged }) =>
        draggable &&
        isBeingDragged &&
        `
      background: ${colors.greylightest};
    `}
`

export const Cell = styled.div`
    color: inherit;
    height: 100%;
    width: 100%;
`

export const SelectedIcon = styled(FontAwesomeIcon)`
    color: ${colors.green};
    opacity: 1;
    margin-left: 10px;
`

export const RemoveIcon = styled(FontAwesomeIcon)`
    color: ${colors.redlight};
    opacity: 0;
    position: absolute;
    right: 10px;
    transition: opacity 0.3s;
    top: 8px;

    li:hover > & {
        cursor: pointer;
        opacity: 1;
    }
`

export const DownloadIcon = styled(FontAwesomeIcon)`
    color: ${colors.green};
    opacity: 0;
    position: absolute;
    right: 30px;
    transition: opacity 0.3s;
    top: 8px;

    li:hover > & {
        cursor: pointer;
        opacity: 1;
    }
`

export const DragIcon = styled(FontAwesomeIcon)`
    color: ${colors.greylight};
    ${({ opaque }) => (opaque ? `opacity: 1;` : `opacity: 0;`)}
    position: absolute;
    left: 10px;
    transition: opacity 0.2s;
    transform: translateY(-50%);
    top: 50%;
    cursor: move;

    li:hover > & {
        opacity: 1;
    }
`

export const DragWrapper = styled.div`
    width: 30px;
    background-color: ${colors.greylight};
    opacity: 1;
    height: 100%;
    position: absolute;
    left: 0px;
    top: 0px;
    opacity: 0.4;
    cursor: move;
`
